import {CAMPAIGN_KEYS} from "@/api/campaignApi";
import {COMPANY_KEYS} from "@/api/companyApi";
import {USER_KEYS} from "@/api/userApi";
import type {CampaignOwnerDetailSerializer, UserDetailSerializer} from "@/generated/DjangoTypes";
import {queryClient} from "@/queryClient";
import type {TCompanyProfile} from "@/store/types";
import type {AxiosResponse} from "axios";

const fetchCampaign = async (id: number) => {
  const cachedCampaign = queryClient.getQueryData<AxiosResponse<CampaignOwnerDetailSerializer>>(
    CAMPAIGN_KEYS.qCampaign(id),
  );

  if (cachedCampaign) {
    return cachedCampaign.data;
  }

  return (
    await queryClient.fetchQuery<AxiosResponse<CampaignOwnerDetailSerializer>>({
      queryKey: CAMPAIGN_KEYS.qCampaign(id),
    })
  )?.data;
};

const fetchCompany = async (id: number) => {
  const cachedCompany = queryClient.getQueryData<AxiosResponse<TCompanyProfile>>(COMPANY_KEYS.qCompany(id));

  if (cachedCompany) {
    return cachedCompany.data;
  }

  return (
    await queryClient.fetchQuery<AxiosResponse<TCompanyProfile>>({
      queryKey: COMPANY_KEYS.qCompany(id),
    })
  )?.data;
};

const fetchMobileAppRedirect = async () => {
  const cachedLink = queryClient.getQueryData<AxiosResponse<{redirect?: string}>>(USER_KEYS.qUserMobileAppRedirect);

  if (cachedLink) {
    return cachedLink.data;
  }

  return (
    await queryClient.fetchQuery<AxiosResponse<{redirect?: string}>>({
      queryKey: USER_KEYS.qUserMobileAppRedirect,
    })
  )?.data;
};

const fetchUser = async (id: number) => {
  const cachedUser = queryClient.getQueryData<AxiosResponse<UserDetailSerializer>>(USER_KEYS.qUser(id));

  if (cachedUser) {
    return cachedUser.data;
  }

  return (
    await queryClient.fetchQuery<AxiosResponse<UserDetailSerializer>>({
      queryKey: USER_KEYS.qUser(id),
    })
  )?.data;
};

export {fetchCampaign, fetchCompany, fetchMobileAppRedirect, fetchUser};
